class Box{
    constructor(max){
        this.nElementi = 0;
        this.piatti = [];
        this.max = max;
        this.totPrezzo = 0;
    }

    addPiatto(p, qta){
        let piatto = this.piatti.find((ps) => {
            return ps.id === p.id;
        });
        if(piatto){
            piatto.qta += qta;
        }else{
            piatto = p;
            this.piatti.push({...piatto, qta: qta})
        }
        this.totPrezzo += qta*piatto.prezzo;
        this.nElementi += qta;
    }

    removePiatto(p, qta){
        let piatto = this.piatti.find((ps) => {
            return ps.id === p.id;
        });
        if(piatto){
            piatto.qta -= qta;
            this.totPrezzo -= qta*piatto.prezzo;
            this.nElementi -= qta;
            if(piatto.qta === 0){
                this.piatti.splice(this.piatti.indexOf(piatto), 1);
            }
        }
    }

    deletePiatto(p){
        let piatto = this.piatti.find((ps) => {
            return ps.id === p.id;
        });
        if(piatto){
            this.totPrezzo -= piatto.qta*piatto.prezzo;
            this.nElementi -= piatto.qta;
            this.piatti.splice(this.piatti.indexOf(piatto), 1);
        }
    }

    getQtaPiatto(p){
        let piatto = this.piatti.find((ps) => {
            return ps.id === p.id;
        });
        if(piatto){
            return piatto.qta;
        }
        return 0;
    }
}

export default Box;